import { usePathname } from "next/navigation"
import React from "react"

interface LinkHelperProps {
  href: string | string[]
  partial?: boolean
  children: (active: boolean) => React.ReactNode
}

const LinkHelper: React.FC<LinkHelperProps> = ({ href, partial = true, children }) => {
  const pathname = usePathname()
  const hrefs = Array.isArray(href) ? href : [href]

  const isMatch = (path: string) => {
    if (partial) {
      // Smart partial match: exact start + next char is boundary
      return pathname === path || pathname.startsWith(path + "/") || pathname.startsWith(path + "?")
    }
    return pathname === path
  }

  const active = hrefs.some(isMatch)

  return <>{children(active)}</>
}

export default LinkHelper
